import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Handshake } from 'lucide-react';

const clients = [
  { id: 1, logo: '/Clients/KENAN.png', name: 'Kenan' },
  { id: 2, logo: '/Clients/mas.png', name: 'Mas' },
  { id: 3, logo: '/Clients/MODERN.png', name: 'Modern' },
  { id: 4, logo: '/Clients/NEOM.png', name: 'NEOM' },
  { id: 8, logo: '/Clients/saudi.png', name: 'Saudi Partnership' },
  { id: 10, logo: '/Clients/saudi2.png', name: 'Saudi Arabia Govt' },
  { id: 11, logo: '/Clients/top.png', name: 'Top Engineering' },
  { id: 5, logo: '/Clients/1.jpg', name: 'Partner 1' },
  { id: 6, logo: '/Clients/2.jpg', name: 'Partner 2' },
  { id: 7, logo: '/Clients/3.jpg', name: 'Partner 3' },
  { id: 9, logo: '/Clients/3.png', name: 'Partner 4' },
  { id: 12, logo: '/Clients/md.jpg', name: 'MD Partners' },
];

const Clients = () => {
  return (
    <div className="bg-slate-50 min-h-screen">
      <Helmet>
        <title>Our Clients | Sooners Land LLC</title>
        <meta name="description" content="Prestigious clients and partners of Sooners Land LLC, including NEOM and various Saudi and international engineering firms." />
      </Helmet>

      {/* Header */}
      <section className="bg-primary pt-32 pb-16 px-6 md:px-12 text-center relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-accent/5 skew-y-3 origin-top-left" />
        <div className="container mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="inline-flex items-center justify-center w-16 h-16 bg-accent-soft rounded-2xl mb-6"
          >
            <Handshake className="text-accent" size={32} />
          </motion.div>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">Trusted Partnerships</h1>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Collaboration is at the heart of our success. We are proud to work with world-class organizations and governments.
          </p>
        </div>
      </section>

      {/* Clients Grid */}
      <section className="section-padding -mt-10">
        <div className="container mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {clients.map((client, index) => (
              <motion.div
                key={client.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="glass-card bg-white p-8 rounded-3xl flex flex-col items-center justify-center aspect-square border border-slate-100 shadow-xl group hover:-translate-y-2 transition-all duration-300"
              >
                <div className="relative w-full h-full flex items-center justify-center">
                  <img 
                    src={client.logo} 
                    alt={client.name} 
                    className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-500 opacity-70 group-hover:opacity-100" 
                  />
                </div>
                <div className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                   <span className="text-[10px] font-bold text-accent uppercase tracking-[0.2em]">{client.name}</span>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Partners Info */}
          <div className="mt-24 text-center max-w-3xl mx-auto">
             <div className="h-0.5 w-24 bg-accent mx-auto mb-8" />
             <p className="text-text-muted text-lg leading-relaxed">
                "We don't just provide services; we build long-term relationships based on trust, quality, and mutual growth. Our clients range from large government entities to innovative private design firms."
             </p>
             <div className="mt-8">
                <span className="font-bold text-primary">Sooners Land Leadership Team</span>
             </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clients;
